{
  "FILTER": {
    "TITLE": "Gespräche filtern",
    "SUBTITLE": "Füge Filter unten hinzu und klicke auf „Filter anwenden“, um das Durcheinander der Chats zu beenden.",
    "EDIT_CUSTOM_FILTER": "Ordner bearbeiten",
    "CUSTOM_VIEWS_SUBTITLE": "Füge Filter hinzu oder entferne sie und aktualisieren deinen Ordner.",
    "ADD_NEW_FILTER": "Filter hinzufügen",
    "FILTER_DELETE_ERROR": "Hoppla, wir können nicht, nichts speichern! Bitte füge mindestens einen Filter hinzu, um ihn zu speichern.",
    "SUBMIT_BUTTON_LABEL": "Filter übernehmen",
    "UPDATE_BUTTON_LABEL": "Ordner aktualisieren",
    "CANCEL_BUTTON_LABEL": "Abbrechen",
    "CLEAR_BUTTON_LABEL": "Filter zurücksetzen",
    "FOLDER_LABEL": "Ordnername",
    "FOLDER_QUERY_LABEL": "Ordnerabfrage",
    "EMPTY_VALUE_ERROR": "Wert ist erforderlich.",
    "TOOLTIP_LABEL": "Gespräche filtern",
    "QUERY_DROPDOWN_LABELS": {
      "AND": "UND",
      "OR": "ODER"
    },
    "INPUT_PLACEHOLDER": "Wert eintragen",
    "OPERATOR_LABELS": {
      "present": "Vorhanden",
      "not_present": "Nicht vorhanden",
      "present_with_answer": "Vorhanden mit Antwort",
      "present_without_answer": "Vorhanden ohne Antwort",
      "equal_to": "Gleich",
      "not_equal_to": "Nicht gleich",
      "does_not_contain": "Beinhaltet nicht",
      "is_present": "Ist anwesend",
      "is_not_present": "Ist nicht anwesend",
      "is_greater_than": "Ist größer als",
      "is_less_than": "Ist kleiner als",
      "starts_with": "Beginnt mit",
      "equalTo": "Gleich",
      "notEqualTo": "Nicht gleich",
      "contains": "Enthält",
      "doesNotContain": "Beinhaltet nicht",
      "isPresent": "Ist anwesend",
      "isNotPresent": "Ist nicht anwesend",
      "isGreaterThan": "Ist größer als",
      "isLessThan": "Ist kleiner als",
      "startsWith": "Beginnt mit",
      "is_greater_than_or_equal": "Ist größer oder gleich",
      "is_less_than_or_equal": "Ist kleiner oder gleich",
      "newer_than_days": "Ist neuer als x Tage (einschließlich)",
      "older_than_days": "Ist älter als x Tage (einschließlich)",
      "isGreaterThanOrEqual": "Ist größer oder gleich",
      "isLessThanOrEqual": "Ist kleiner oder gleich"
    },
    "ATTRIBUTE_LABELS": {
      "TRUE": "Ja",
      "FALSE": "Nein"
    },
    "ATTRIBUTES": {
      "STATUS": "Status",
      "ASSIGNEE_NAME": "Bearbeiter Name",
      "INBOX_NAME": "Posteingangsname",
      "TEAM_NAME": "Teamname",
      "CONVERSATION_IDENTIFIER": "Konversation-ID",
      "CAMPAIGN_NAME": "Kampagnenname",
      "LABELS": "Labels",
      "BROWSER_LANGUAGE": "Browsersprache",
      "PRIORITY": "Priorität",
      "COUNTRY_NAME": "Landesname",
      "REFERER_LINK": "Referer-Link",
      "CUSTOM_ATTRIBUTE_LIST": "Liste",
      "CUSTOM_ATTRIBUTE_TEXT": "Text",
      "CUSTOM_ATTRIBUTE_NUMBER": "Nummer",
      "CUSTOM_ATTRIBUTE_LINK": "Link",
      "CUSTOM_ATTRIBUTE_CHECKBOX": "Checkbox",
      "CREATED_AT": "Erstellt am",
      "LAST_ACTIVITY": "Letzte Aktivität",
      "LAST_CUSTOMER_MESSAGE_AT": "Letzte Kundennachricht",
      "PHONE_CALL": "Telefonanruf",
      "RATING": "Bewertung",
      "CSAT": "CSAT"
    },
    "ERRORS": {
      "VALUE_REQUIRED": "Wert ist erforderlich",
      "ATTRIBUTE_KEY_REQUIRED": "Attribut-Schlüssel ist erforderlich",
      "FILTER_OPERATOR_REQUIRED": "Filter-Operator ist erforderlich",
      "VALUE_MUST_BE_BETWEEN_1_AND_998": "Wert muss zwischen 1 und 998 liegen",
      "VALUE_MUST_BE_BETWEEN_0_AND_998": "Wert muss zwischen 0 und 998 liegen"
    },
    "GROUPS": {
      "STANDARD_FILTERS": "Standard Filter",
      "ADDITIONAL_FILTERS": "Zusätzliche Filter",
      "CUSTOM_ATTRIBUTES": "Benutzerdefinierte Attribute"
    },
    "CUSTOM_VIEWS": {
      "ADD": {
        "TITLE": "Möchten Sie diesen Filter speichern?",
        "LABEL": "Diesen Filter benennen",
        "PLACEHOLDER": "Benenne deinen Filter, um ihn später wiederzuerkennen.",
        "ERROR_MESSAGE": "Name wird benötigt.",
        "SAVE_BUTTON": "Filter speichern",
        "CANCEL_BUTTON": "Abbrechen",
        "API_FOLDERS": {
          "SUCCESS_MESSAGE": "Ordner erfolgreich erstellt.",
          "ERROR_MESSAGE": "Fehler beim Erstellen des Ordners."
        },
        "API_SEGMENTS": {
          "SUCCESS_MESSAGE": "Segment erfolgreich erstellt.",
          "ERROR_MESSAGE": "Fehler beim Erstellen des Segments."
        }
      },
      "EDIT": {
        "EDIT_BUTTON": "Ordner bearbeiten",
        "API_FOLDERS": {
          "ERROR_MESSAGE": "Fehler beim Aktualisieren des Ordners."
        }
      },
      "DELETE": {
        "DELETE_BUTTON": "Filter löschen",
        "MODAL": {
          "CONFIRM": {
            "TITLE": "Löschen bestätigen",
            "MESSAGE": "Möchten Sie den Filter wirklich löschen ",
            "YES": "Ja, löschen",
            "NO": "Nein, behalte es"
          }
        },
        "API_FOLDERS": {
          "SUCCESS_MESSAGE": "Ordner erfolgreich gelöscht.",
          "ERROR_MESSAGE": "Fehler beim Löschen des Ordners."
        },
        "API_SEGMENTS": {
          "SUCCESS_MESSAGE": "Segment erfolgreich gelöscht.",
          "ERROR_MESSAGE": "Fehler beim Löschen des Segments."
        }
      }
    },
    "AI_PROMPT": "KI-Filter",
    "TEAMS_LABEL": "Teilen mit",
    "PARENT_FOLDER_LABEL": "Übergeordneter Ordner",
    "NO_PARENT_FOLDER": "Kein übergeordneter Ordner",
    "BACKGROUND_COLOR_LABEL": "Hintergrundfarbe",
    "COLOR_LABEL": "Farbe",
    "SELECT_COLOR": "Farbe auswählen",
    "CLEAR_SELECTION": "Auswahl zurücksetzen",
    "SORT_BY_LABEL": "Sortieren nach",
    "PHONE_CALL_TYPES": {
      "INBOUND": "Eingehend",
      "OUTBOUND": "Ausgehend",
      "MISSED": "Verpasst",
      "UNHANDLED_MISSED": "Unbearbeitet verpasst"
    },
    "RATING_TYPES": {
      "UP": "Daumen hoch",
      "DOWN": "Daumen runter"
    }
  }
}
